import React from 'react';

import { useMediaQuery } from 'ha/helpers/MediaQuery';

import NavBarDesktop from '../containers/NavBarDesktop';
import NavBarMobile from '../containers/NavBarMobile';

export const NavBar: React.FC = () => {
  const { md } = useMediaQuery();

  return md ? <NavBarDesktop /> : <NavBarMobile />;
};

export default NavBar;
